import { IsoTimestamp } from '../../../@harmony';

export const UNLIMITED_SEATS = 9999999;

export enum SubscriptionInterval {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

export enum SubscriptionStatus {
  /** Active subscription */
  Active = 'active',
  /** Canceled, will expire at end of the interval */
  Canceled = 'canceled',
  /** Legacy products, subscribed via Stripe checkout links */
  Legacy = 'legacy',
  /** Trial period for some users */
  Trial = 'trial',
  /** Unpaid, Incomplete expired… and other invalid states */
  Invalid = 'invalid',
}

export interface SubscriptionEntityV0 {
  _version: 0;
  status: SubscriptionStatus;
  seats: number;
  endDate: IsoTimestamp;
  productId: string;
  priceId: string;
  customerId: string;
  subscriptionId: string;
  price: number;
  currency: string;
  interval: SubscriptionInterval;
  lastSyncedAt: IsoTimestamp;
}

export type SubscriptionEntity = SubscriptionEntityV0;
export type AnySubscriptionEntityVersion = SubscriptionEntityV0; // TODO use union: `| v1 | v2 | v3`
